import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SelectOptionProps } from "utils/common-types";

interface WithdrawState {
  stateList?: SelectOptionProps[] | null;
  bankStateList?: SelectOptionProps[] | null;
}
const initialState: WithdrawState = { stateList: null, bankStateList: null };
const withdrawStateSlice = createSlice({
  name: "Withdraw State Slice",
  initialState,
  reducers: {
    setState(state, action: PayloadAction<SelectOptionProps[] | null>) {
      state.stateList = action.payload;
    },
    setBankState(state, action: PayloadAction<SelectOptionProps[] | null>) {
      state.bankStateList = action.payload;
    },
  },
});
export const { setState, setBankState } = withdrawStateSlice.actions;
export default withdrawStateSlice.reducer;
